import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PlanDefaultValues, PlanModel } from 'src/app/components/participants/plans/plan';
import { PlanDetailsFormComponent } from 'src/app/components/participants/plans/plan-details-form/plan-details-form.component';
import { ParticipantThemeService } from 'src/app/services/participant-theme.service';
import { PlanService } from 'src/app/services/plan.service';
import { ToastService } from 'src/app/services/toast-service.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
    selector: 'app-edit-plan',
    templateUrl: './edit-plan.component.html',
    styleUrls: ['./edit-plan.component.scss'],
    standalone: false
})
export class EditPlanComponent {
  planDetails: PlanModel = PlanDefaultValues();
  planId: string = '';
  isSubmitted: boolean = false;
   participantClassByRole: string = '';
   translations: any;
   llttfPage: boolean = false;
  @ViewChild(PlanDetailsFormComponent) plandetailsform!: PlanDetailsFormComponent;

  constructor(private _planservice: PlanService,
    private route: ActivatedRoute,
    private router: Router,
    private toastservice: ToastService,
    private translationservice: TranslationService,
    private themeService: ParticipantThemeService
  ) { }

  ngOnInit(): void {

    this.route.params.subscribe(params => {
      this.planDetails.id = this.planId = params['planid'];

      this._planservice.getPlanDetailsForUpdate(this.planId).subscribe({
        next: (response) => {
          this.planDetails = response;
        }
      })
    })

    this.translationservice.getTranslation().subscribe({
      next: (response) => {
        this.translations = response;
      }
    });

    this.themeService.setParticipantTheme();
    this.participantClassByRole = this.themeService.participantClassByRole;
    this.llttfPage = this.themeService.llttfPage;

  }

  updatePlan() {
    this.isSubmitted = true;

    if (!this.plandetailsform.validateRequiredFields()) {
      this.toastservice.showErrorMessage('Please fill all required fields');
      return;
    }

    this._planservice.updatePlan(this.planDetails).subscribe({
      next: () => {
        this.toastservice.showMessage("Plan Update Successfully");
        this.router.navigateByUrl('/dashboard-participant');
      }
    });
  }

}
